class SiteContentConstants {
    static readonly ContentIndexPageTitle: string = 'Help';
}

export default SiteContentConstants;
